/* eslint-disable import/no-named-default */

import { default as Sector } from './Sector';
import { default as Division } from './Division';
import { default as BudgetCode } from './BudgetCode';
import { default as Environments } from './Environments';
import { default as DataClassification } from './DataClassification';
import { default as ApplicationShortName } from './ApplicationShortName';
import { default as AppOwnerSearch } from './AppOwnerSearch';
import { default as NonPrivilegedADGroupOwner } from './NonPrivilegedADGroupOwner';
import { default as PrivilegedADGroupOwner } from './PrivilegedADGroupOwner';
import { default as BusinessContact } from './BusinessContact';
import { default as NonPrivilegedADGroupModal } from './NonPrivilegedADGroupModal';
import { default as ADGroupReader } from './ADGroupReader';
import { default as PrivilegedADGroupModal } from './PrivilegedADGroupModal';
import { default as ADGroupContributor } from './ADGroupContributor';
import { default as AppOwner } from './AppOwner';
import { default as ApplicationRegion } from './ApplicationRegion';
import { default as AddADGroups } from './AddADGroups';
import { default as PrivilegedADGroup } from './PrivilegedADGroup';
import { default as NonPrivilegedADGroup } from './NonPrivilegedADGroup';
import { default as ApplicationName } from './ApplicationName';
import { default as Program } from './Program';
import { default as AppContextPath } from './AppContextPath';
import { default as Application } from './Application';
import { default as PreviousOrderID } from './PreviousOrderID';
import { default as IsExternalRadio } from './IsExternalRadio';
import { default as AppUrl } from './AppUrl';
import { default as ApplicationSupportDl } from './ApplicationSupportDl';
import { default as CertificateOwnerOne } from './CertificateOwnerOne';
import { default as CertificateOwnerTwo } from './CertificateOwnerTwo';
import { default as ISANumber } from './ISAnumber';
import { default as ITEApplicationService } from './ITEApplicationService';
import { default as ADCertGroup } from './ADCertGroup';

const Forms = {
    Sector,
    Division,
    BudgetCode,
    Environments,
    DataClassification,
    ApplicationShortName,
    AppOwnerSearch,
    NonPrivilegedADGroupOwner,
    PrivilegedADGroupOwner,
    BusinessContact,
    NonPrivilegedADGroupModal,
    ADGroupReader,
    PrivilegedADGroupModal,
    ADGroupContributor,
    NonPrivilegedADGroup,
    PrivilegedADGroup,
    ApplicationRegion,
    AddADGroups,
    AppOwner,
    ApplicationName,
    Program,
    AppContextPath,
    Application,
    PreviousOrderID,
    IsExternalRadio,
    AppUrl,
    ApplicationSupportDl,
    CertificateOwnerOne,
    CertificateOwnerTwo,
    ISANumber,
    ITEApplicationService,
    ADCertGroup,
};

export default Forms;
